import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { mediaActions, mediaSelectors } from '../redux/media-reducer';
import { AudioRecorder } from '../utils/AudioRecorder';
import { registerStoppableMedia, stopAllMedia } from '../utils/media-stopping-utils';
import { SpeechButton } from './SpeechButton';

/**
 * RecordButton records audio.  It presents using the SpeechButton
 */

var RecordButtonBase = function (_PureComponent) {
  _inherits(RecordButtonBase, _PureComponent);

  function RecordButtonBase(props) {
    _classCallCheck(this, RecordButtonBase);

    var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

    _this.handleRecordingStarted = function () {
      _this.props.setRecordingStarted(_this);
      if (_this.props.onRecordStart) {
        _this.props.onRecordStart();
      }
    };

    _this.handleRecordingDone = function () {
      _this.props.setRecordingStopped();
      var newAudio = {
        audioBlob: _this.audioRecorder.getAudioBlob(),
        audioUri: _this.audioRecorder.getAudioUri()
      };
      _this.setState(newAudio);
      _this.audioRecorder.reset();
      _this.audioRecorder = null;
      if (_this.props.onRecordStop) {
        _this.props.onRecordStop(newAudio);
      }
    };

    _this.handleError = function (errorMsg) {
      if (errorMsg.indexOf('NotAllowedError') !== -1) {
        alert('Recording is being blocked, please unblock it in your browser settings.');
      } else {
        _this.props.handleError(errorMsg);
      }
    };

    _this.handleClick = function () {
      if (_this.props.disabled) {
        return;
      }
      if (_this.props.isRecording && RecordButtonBase.activeRecordButton === _this) {
        _this.audioRecorder.stopRecording();
        RecordButtonBase.activeRecordButton = null;
      } else {
        stopAllMedia();
        _this.setState({
          audioBlob: null,
          audioUri: null
        });
        _this.audioRecorder = new AudioRecorder();
        _this.audioRecorder.setErrorHandler(_this.handleError);
        _this.audioRecorder.setStartedRecordingHandler(_this.handleRecordingStarted);
        _this.audioRecorder.setDoneRecordingHandler(_this.handleRecordingDone);
        RecordButtonBase.activeRecordButton = _this;
        _this.audioRecorder.startRecording();
      }
    };

    _this.state = {
      audioBlob: null,
      audioUri: null
    };
    _this.audioRecorder = null;
    return _this;
  }

  RecordButtonBase.prototype.componentWillUnmount = function componentWillUnmount() {
    if (RecordButtonBase.activeRecordButton === this) {
      RecordButtonBase.activeRecordButton = null;
    }
    if (this.audioRecorder) {
      this.audioRecorder.reset();
      this.audioRecorder = null;
    }
  };

  RecordButtonBase.prototype.render = function render() {
    return React.createElement(SpeechButton, {
      buttonSize: this.props.buttonSize,
      labelColor: this.props.labelColor,
      isListening: this.props.isRecording,
      isStoppable: true,
      disabled: !!this.props.disabled,
      onClick: this.handleClick,
      speakText: this.props.speakText,
      stopText: this.props.stopText
    });
  };

  return RecordButtonBase;
}(PureComponent);

RecordButtonBase.propTypes = {
  buttonSize: PropTypes.number.isRequired,
  labelColor: PropTypes.string,
  disabled: PropTypes.bool,
  onRecordStart: PropTypes.func,
  // signature is onRecordStop({ audioBlob, audioUri })
  onRecordStop: PropTypes.func,
  speakText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  stopText: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
RecordButtonBase.activeRecordButton = null;

RecordButtonBase.stopAll = function () {
  if (RecordButtonBase.activeRecordButton) {
    RecordButtonBase.activeRecordButton.audioRecorder.stopRecording();
    RecordButtonBase.activeRecordButton = null;
  }
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isRecording: mediaSelectors.isRecording(state)
  };
};

var mappedActions = {
  setRecordingStarted: mediaActions.startRecorderRecording,
  setRecordingStopped: mediaActions.stopRecorderRecording,
  handleError: mediaActions.handleError
};

export var RecordButton = connect(mapStateToProps, mappedActions)(RecordButtonBase);

registerStoppableMedia(RecordButton);